var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFlag48Filled = function SvgIconFlag48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 11.92H27L25.83 9.8c-.51-.92-1.48-1.5-2.54-1.5H12c-.94 0-1.7.76-1.7 1.7v28h3.4V26.08H23l1.17 2.12c.51.92 1.48 1.5 2.54 1.5h8.09c1.6 0 2.9-1.3 2.9-2.9V14.82c0-1.6-1.3-2.9-2.9-2.9Z",
    fill: "current"
  })));
};
export default SvgIconFlag48Filled;